import React from 'react';
import t from 'tcomb-form';
import Select from 'react-select';
import moment from 'moment';

import TimeManager from './utils/TimeManager';

// Init the manager which provides us the data we need
const timeManager = new TimeManager();


/**
 * Timepicker input widget.
 */
class TimePicker extends t.form.Textbox {
    getTemplate() {
        return (locals) => {
            let value = undefined;
            if (locals.value && !moment(locals.value, 'h:mm A', true).isValid()) {
                value = moment(locals.value).utcOffset(locals.value);
                value = value.format('h:mm A');
            }
            let classNames = ["form-group", 'form-group-depth-' + locals.path.length];
            let input = <input  onBlur={locals.attrs.onBlur.bind(null, locals.path)} disabled={locals.disabled} defaultValue={value ? value: locals.value}/>;
            if (!locals.disabled) {
                input = (
                    <Select
                        name="form-field-name"
                        asyncOptions={timeManager.search.bind(timeManager)}
                        cacheAsyncResults={false}
                        filterOptions={(options) => options || []}
                        onChange={locals.onChange}
                        onBlur={locals.attrs.onBlur.bind(null, locals.path)}
                        value={value ? value : locals.value}
                        placeholder={''} />
                );
            }
            return (
                <div className={classNames.join(' ')}>
                    {input}
                    {locals.error ? <span className="help-block error-block">{locals.error}</span> : null}
                </div>
            );
        };
    }
}


module.exports = TimePicker;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/TimePicker.js
 **/